import * as React from "react";

import { Button } from "@/components/ui/button";
import { WORKSPACE_HUB_PATH } from "./workspaceRoutes";

export type WorkspaceErrorFallbackProps = {
  title?: string;
  description?: string;
  onRetry?: () => void;
};

export function WorkspaceErrorFallback({
  title = "Workspace unavailable",
  description = "Something went wrong loading this workspace view.",
  onRetry,
}: WorkspaceErrorFallbackProps): React.ReactElement {
  return (
    <div
      data-workspace-error-fallback=""
      className="flex min-h-[280px] flex-col items-center justify-center gap-4 rounded-md border border-dashed border-border px-6 py-10 text-center dark:border-input"
    >
      <div className="max-w-md space-y-2">
        <h2 className="font-[family-name:var(--font-primary)] text-base font-medium">{title}</h2>
        <p className="font-[family-name:var(--font-primary)] text-sm text-muted-foreground">
          {description}
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {onRetry ? (
          <Button type="button" variant="outline" size="sm" onClick={onRetry}>
            Try again
          </Button>
        ) : null}
        <Button type="button" variant="secondary" size="sm" asChild>
          <a href={WORKSPACE_HUB_PATH}>Back to hub</a>
        </Button>
      </div>
    </div>
  );
}
